export default apiFetch => async payload => {
  const response = await apiFetch({
    endpoint: "latestArticles",
    method: "post",
    body: payload
  });

  return await response.json();
};
